<template>
    <div class="border-t border-neutral-200 dark:border-neutral-700 flex items-center justify-between cursor-pointer hover:bg-neutral-200 dark:hover:bg-neutral-700"
         @click="handleBandEdit">
        <div class="flex items-center p-3 min-w-0">
            <div class="h-4 w-4 border border-neutral-800 dark:border-neutral-100 rounded-full"
                 :style="`background: ${resource.color};`"></div>
            <div class="ml-3 min-w-0">
                <div class="font-semibold truncate">{{ resource.name }}</div>
            </div>
        </div>
        <div class="px-3 py-2 text-right text-xs text-neutral-500 dark:text-neutral-400 shrink-0">
            {{ resistance }}
        </div>
    </div>
</template>

<script>
export default {
  name: 'ResourceListItem',
  computed: {
    band() {
      return this.resource;
    },
    resistance() {
      return this.resource.resistanceFormatted(this.user.systemOfMeasure);
    },
    user() {
      return this.$store.getters['auth/user'];
    },
  },
  methods: {
    handleBandEdit() {
      this.$router.push(`/band/${this.band.uuid}/edit`);
    },
  },
  props: {
    resource: {
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">

</style>
